import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    show: false
};
export const loadingSlice = createSlice({
    name: "loading",
    initialState: initialState,
    reducers: {
        changeLoadingState: (state, action) => {
            state.show = action.payload.show
        },
    }
})

export const { changeLoadingState } = loadingSlice.actions;
export default loadingSlice.reducer;